/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CompositeSearchEnhancedFilterConditionType } from './CompositeSearchEnhancedFilterConditionType';

export type CompositeSearchEnhancedFilterJobFamily = {
    filterType: CompositeSearchEnhancedFilterJobFamily.filterType;
    conditionType: CompositeSearchEnhancedFilterConditionType;
    value: Array<number>;
};

export namespace CompositeSearchEnhancedFilterJobFamily {

    export enum filterType {
        JOB_FAMILY = 'jobFamily',
    }


}

